import React from 'react';
import { Box, Typography, Paper } from '@material-ui/core';
import FlashOnIcon from '@material-ui/icons/FlashOn';
import ShowChartIcon from '@material-ui/icons/ShowChart';
import BarChartIcon from '@material-ui/icons/BarChart';
import SpeedIcon from '@material-ui/icons/Speed';
import { Link } from 'react-router-dom';
import { getQueryParams } from '../../../utils/fns/get-query-params';
import { useTranslation } from 'react-i18next';
import EmojiEmotionsOutlinedIcon from '@material-ui/icons/EmojiEmotionsOutlined';
import { isFlindexClientAccess } from '../../../hooks/useFlindexClientAccess';

const shortcuts = [
  {
    translationKey: 'home.access.quickview',
    icon: <FlashOnIcon />,
    path: '/quickview',
    color: '#7C3AED',
  },
  {
    translationKey: 'home.access.operational-status',
    icon: <ShowChartIcon />,
    path: '/estadoOperativo',
    color: '#6366F1',
  },
  {
    translationKey: 'home.access.general-status',
    icon: <BarChartIcon />,
    path: '/generalStatus',
    color: '#8B5CF6',
  },
  {
    translationKey: 'home.access.apdex-dashboard',
    icon: <SpeedIcon />,
    path: '/apdex',
    color: '#4F46E5',
  },
  {
    translationKey: 'home.access.sentiment',
    icon: <EmojiEmotionsOutlinedIcon />,
    path: '/sentimiento',
    color: '#4F46E5',
    requiresAtentus: true,
  }
];

export function HomeShortcuts() {
  const { t } = useTranslation();

  return (
    <Box 
      display="flex" 
      alignItems="center" 
      flexWrap="wrap" 
      style={{ 
        gap: '12px',
        alignItems: 'center' 
      }}
    >
      <Typography
        variant="subtitle1"
        style={{
          fontWeight: 800,
          color: '#111827',
          marginRight: '8px',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {t('home.access.title')}:
      </Typography>
      {shortcuts
        .filter((s) => !s.requiresAtentus || isFlindexClientAccess())
        .map((shortcut, index) => (
        <Paper
          key={index}
          component={Link}
          to={{
            pathname: shortcut.path,
            search: getQueryParams(),
          }}
          elevation={0}
          style={{
            textDecoration: 'none',
            padding: '10px 20px',
            borderRadius: '50px',
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#FFFFFF',
            border: '1px solid #E5E7EB',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.02)',
            transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
            cursor: 'pointer',
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor = '#F9FAFB';
            e.currentTarget.style.borderColor = shortcut.color;
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.05)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.backgroundColor = '#FFFFFF';
            e.currentTarget.style.borderColor = '#E5E7EB';
            e.currentTarget.style.transform = 'none';
            e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.02)';
          }}
        >
          <Box
            style={{
              color: shortcut.color,
              marginRight: '8px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {React.cloneElement(shortcut.icon, { style: { fontSize: '22px' } })}
          </Box>
          <Typography
            variant="body1"
            style={{
              fontWeight: 700,
              color: '#374151',
              fontSize: '0.95rem',
            }}
          >
            {t(shortcut.translationKey)}
          </Typography>
        </Paper>
      ))}
    </Box>
  );
}
